
<div class="container">
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
      <div class="alert alert-info" *ngIf="message"><span>{{ message }}</span></div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <p class="text-center">Export Initial Pagecount Form</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" [downloadFile]="'/api/DeploymentWorkflow/export-initial-pagecounts'" [params]="{deploymentId: deploymentId, projectId: projectId}"><span class="oi oi-cloud-download"></span> Export Initial Pagecounts</a></div>
    <div class="col"> </div>
  </div>
</div>